import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../utils/Const";
import "../Login&Register/LoginRegister.css";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const Register = () => {
   const navigate = useNavigate();

   const [registrationType, setRegistrationType] = useState("");
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [formData, setFormData] = useState({
      shop_type: "",
      owner: "",
      mobile: "",
      address: "",
      email: "",
      password: "",
   });
   
   const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
   };


   const handleDropdownChange = (e) => {
      setRegistrationType(e.target.value);
   };

   const handleInputFocus = () => {
      toast.dismiss();
   };


   const handleSubmit = async (e) => {
  e.preventDefault();
  toast.dismiss();
  setIsSubmitting(true);


  if (!registrationType) {
    toast.error("Please select your registration type first.");
    setIsSubmitting(false);
    return;
  }

  const isEmpty = Object.values(formData).every(value => !value);
  if (isEmpty) {
    toast.warning("Please fill in all the required fields.");
    setIsSubmitting(false);
    return;
  }


  const fieldsToValidate = [
    { key: "shop_type", label: "Store Name" },
    { key: "owner", label: "Owner's Name" },
    { key: "email", label: "Email" },
    { key: "mobile", label: "Mobile Number" },
    { key: "address", label: "Address" },
    { key: "password", label: "Password" }
  ];

  for (const { key, label } of fieldsToValidate) {
    if (!formData[key]) {
      toast.warning(`Please enter ${label}`);
      document.querySelector(`[name="${key}"]`)?.focus();
      setIsSubmitting(false);
      return;
    }
  }

  
  if (formData.email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      document.querySelector('[name="email"]')?.focus();
      setIsSubmitting(false);
      return;
    }
  }

  if (formData.mobile) {
    const mobilePattern = /^[0-9]{10}$/;
    if (!mobilePattern.test(formData.mobile)) {
      toast.error("Please enter a valid 10-digit mobile number.");
      document.querySelector('[name="mobile"]')?.focus();
      setIsSubmitting(false);
      return;
    }
  }
  console.log(`${baseUrl}register`);
      try {
         const response = await axios.post(`${baseUrl}register`, {
            ...formData,
            type: registrationType,
         });
         
         console.log("Registration successful:", response);
         
         // Show success toast
         toast.success(response.data.msg || "Registration successful!", { 
            position: "top-right", 
            zIndex: 9999,
            onClose: () => navigate("/") // Navigate after toast closes
         });
         
      } catch (error) {
         console.log("Error:", error);
         
         // Handle specific error cases
         if (error.response?.status === 400) {
            toast.error("Email already exists. Please use a different email.");
         } else if (error.response?.status === 401) {
            toast.error("Mobile number already exists. Please use a different mobile number.");
         } else if (error.response?.data?.msg) {
            toast.error(error.response.data.msg);
         } else {
            toast.error("Registration failed. Please try again.");
         }
      }
      setIsSubmitting(false);
   };

   return (
      <div className="img">
         <ToastContainer />
         <div className="flex justify-center z-[1] items-center min-h-screen py-8">
            <div className="backdrop-blur-[2px]">
               
               <form
                  onSubmit={handleSubmit}
                  className="bg-gradient-to-br from-[#FFF8F0] to-[#F8F3E9] border-2 border-[#E6B17E] shadow-2xl rounded-2xl px-8 py-6 max-w-2xl w-full"
               >
                  {/* Logo/Title Section */}
                  <div className="text-center mb-6">
                     <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-[#D35400] to-[#E67E22] rounded-full mb-4 shadow-lg">
                        <span className="text-3xl text-white font-bold">CR</span>
                     </div>
                     <p className="text-3xl font-bold bg-gradient-to-r from-[#D35400] to-[#E67E22] bg-clip-text text-transparent">
                        CloudRasoi
                     </p>
                     <p className="text-sm text-[#7E6B5A] mt-2">Restaurant Management System</p>
                  </div>

                  <h2 className="text-2xl font-bold mb-2 text-center text-[#2C3E50]">
                     Register Your {registrationType === "store" ? "Store" : "Restaurant"}
                  </h2>
                  <p className="text-[#7E6B5A] mb-6 text-center">
                     Create your account to get started
                  </p>

                  {/* Registration Type Selection */}
                  <div className="mb-6">
                     <label
                        htmlFor="registrationType"
                        className="block text-[#5D4037] text-sm font-semibold mb-3"
                     >
                        Select Registration Type: <span className="text-[#D32F2F]">*</span>
                     </label>
                     <div className="relative">
                        <select
                           id="registrationType"
                           value={registrationType}
                           onChange={handleDropdownChange}
                           onFocus={handleInputFocus}
                           className="w-full p-3 rounded-lg border-2 border-[#D7CCC8] bg-white text-[#5D4037] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300 appearance-none"
                        >
                           <option value="">Select Registration Type</option>
                           <option value="store">Store</option>
                           {/* <option value="restaurant">Restaurant</option> */}
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-[#5D4037]">
                           <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                           </svg>
                        </div>
                     </div>
                  </div>

                  {/* Form Fields */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                     {/* Store Name */}
                     <div>
                        <label htmlFor="shop_type" className="block text-[#5D4037] text-sm font-semibold mb-2">
                           {registrationType === "store" ? "Store Name" : "Restaurant Name"} <span className="text-[#D32F2F]">*</span>
                        </label>
                        <input
                           type="text"
                           id="shop_type"
                           name="shop_type"
                           placeholder={`Enter ${registrationType === "store" ? "Store" : "Restaurant"} Name`}
                           value={formData.shop_type}
                           onChange={handleChange}
                           onFocus={handleInputFocus}
                           className="w-full p-3 rounded-lg border-2 border-[#D7CCC8] bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300"
                        />
                     </div>

                     {/* Owner's Name */}
                     <div>
                        <label htmlFor="owner" className="block text-[#5D4037] text-sm font-semibold mb-2">
                           Owner's Name <span className="text-[#D32F2F]">*</span>
                        </label>
                        <input
                           type="text"
                           id="owner"
                           name="owner"
                           placeholder="Enter Owner's Name"
                           value={formData.owner}
                           onChange={handleChange}
                           onFocus={handleInputFocus}
                           className="w-full p-3 rounded-lg border-2 border-[#D7CCC8] bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300"
                        />
                     </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                     {/* Email */}
                     <div>
                        <label htmlFor="email" className="block text-[#5D4037] text-sm font-semibold mb-2">
                           Email <span className="text-[#D32F2F]">*</span>
                        </label>
                        <input
                           type="email"
                           id="email"
                           name="email"
                           placeholder="Enter Email Address"
                           value={formData.email}
                           onChange={handleChange}
                           onFocus={handleInputFocus}
                           className={`w-full p-3 rounded-lg border-2 bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300`}
                        />
                     </div>

                     {/* Mobile Number */}
                     <div>
                        <label htmlFor="mobile" className="block text-[#5D4037] text-sm font-semibold mb-2">
                           Mobile Number <span className="text-[#D32F2F]">*</span>
                        </label>
                        <input
                           type="number"
                           id="mobile"
                           name="mobile"
                           placeholder="Enter 10-digit Mobile Number"
                           value={formData.mobile}
                           onChange={handleChange}
                           onFocus={handleInputFocus}
                           className={`w-full p-3 rounded-lg border-2 bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300`}
                        />
                     </div>
                  </div>

                  {/* Address */}
                  <div className="mb-4">
                     <label htmlFor="address" className="block text-[#5D4037] text-sm font-semibold mb-2">
                        Address <span className="text-[#D32F2F]">*</span>
                     </label>
                     <input
                        type="text"
                        id="address"
                        name="address"
                        placeholder="Enter Complete Address"
                        value={formData.address}
                        onChange={handleChange}
                        onFocus={handleInputFocus}
                        className="w-full p-3 rounded-lg border-2 border-[#D7CCC8] bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300"
                     />
                  </div>

                  {/* Password */}
                  <div className="mb-8">
                     <label htmlFor="password" className="block text-[#5D4037] text-sm font-semibold mb-2">
                        Password <span className="text-[#D32F2F]">*</span>
                     </label>
                     <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Enter Password"
                        value={formData.password}
                        onChange={handleChange}
                        onFocus={handleInputFocus}
                        className="w-full p-3 rounded-lg border-2 border-[#D7CCC8] bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300"
                     />
                     <p className="text-[#7E6B5A] text-xs mt-1">Use a strong password with at least 8 characters</p>
                  </div>

                  {/* Submit Button */}
                  <button
                     type="submit"
                     disabled={isSubmitting}
                     className="w-full bg-gradient-to-r from-[#D35400] to-[#E67E22] hover:from-[#E67E22] hover:to-[#D35400] text-white font-bold py-3.5 px-4 rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#E67E22] focus:ring-offset-2 disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                     {isSubmitting ? (
                        <span className="flex items-center justify-center">
                           <svg className="animate-spin h-5 w-5 mr-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                           </svg>
                           Creating Account...
                        </span>
                     ) : (
                        'Register Now'
                     )}
                  </button>

                  {/* Login Link */}
                  <div className="mt-8 pt-6 border-t border-[#D7CCC8]">
                     <p className="text-center text-[#7E6B5A]">
                        Already have an account?{" "}
                        <Link
                           to="/"
                           className="font-bold text-[#D35400] hover:text-[#E67E22] hover:underline underline-offset-2 transition-colors duration-300"
                        >
                           Login Here
                        </Link>
                     </p>
                  </div>

                  {/* Terms and Conditions */}
                  <div className="mt-6 text-center">
                     <p className="text-xs text-[#A1887F]">
                        By registering, you agree to our{" "}
                        <Link to="/terms" className="text-[#D35400] hover:underline">
                           Terms of Service
                        </Link>{" "}
                        and{" "}
                        <Link to="/privacy" className="text-[#D35400] hover:underline">
                           Privacy Policy
                        </Link>
                     </p>
                  </div>
               </form>
            </div>
         </div>
      </div>
   );
};

export default Register;